export default (params) => ({
  trigger: {
    name: 'product_collection.show_collection',
    params: params,
  },
  config: {
    schema: {
      item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'multi_discriminant_selector',
          'drop_down_selector',
          'drop_down_panel',
          'direct_collection',
          'stepped_selector',
          'collapsed_selector',
        ],
      },
    },
    event: {
      name: 'show_items',
    },
    nonInt: true,
  },
});
